import { render, staticRenderFns } from "./AdminOrderSummary.vue?vue&type=template&id=2e9ae241"
import script from "./AdminOrderSummary.vue?vue&type=script&lang=js"
export * from "./AdminOrderSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e9ae241')) {
      api.createRecord('2e9ae241', component.options)
    } else {
      api.reload('2e9ae241', component.options)
    }
    module.hot.accept("./AdminOrderSummary.vue?vue&type=template&id=2e9ae241", function () {
      api.rerender('2e9ae241', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/AdminOrderSummary.vue"
export default component.exports